import { DexDispatcherFormEnumType } from '@mark43/cad-api';
import { WorkspacePanel } from '../workspace-panel';
import { WorkspaceStore } from '../workspace-store';
import { PanelStateForWorkspacePanelType } from '../workspace-panel-types';

export function handleExistingDexFormPanel({
    dexFormQuery,
    existingPanel,
    workspacePanelsStore,
    panelState,
}: {
    dexFormQuery: DexDispatcherFormEnumType;
    existingPanel: WorkspacePanel;
    workspacePanelsStore: WorkspaceStore;
    panelState: PanelStateForWorkspacePanelType<'DATA_EXCHANGE_FORM'>;
}) {
    if (existingPanel?.dexForm !== dexFormQuery) {
        existingPanel.updateDexForm(dexFormQuery);
    }

    Object.entries(panelState).forEach(([key, value]) => {
        existingPanel.updatePanelState(key as keyof typeof panelState, value);
    });

    workspacePanelsStore.bringPanelToFront(existingPanel);
}
